import { ListingTopSectionAction } from "../ListingTopSectionAction";
import { ShareOutlined } from "@mui/icons-material";
import { useIsMobileScreenSize } from "../../../../../hooks/global/useIsMobileScreenSize";
import { invokeMobileShareDialog } from "../../../../../lib/global/invokeMobileShareDialog";
import { useShareContext } from "./ListingShareProvider";
import { ListingShareModal } from "./ListingShareModal";
import { useListingShareModalType } from "../../../../../hooks/trainingPlan";

export const ListingShare = () => {
  const isMobile = useIsMobileScreenSize();
  const { state, dispatch } = useShareContext();

  useListingShareModalType();

  return (
    <ListingTopSectionAction
      onClick={() => {
        if (isMobile && navigator?.share) {
          invokeMobileShareDialog({
            title: `Pod1um ${state.type}`,
            text: `Here's a ${state.type} from Pod1um`,
            url: window.location.href,
          });
        } else if (!isMobile || !navigator?.share) {
          if (state.modal.length >= 1) {
            dispatch({ modal: [] });
            return;
          }

          dispatch({ modal: [<ListingShareModal key={1} />] });
        }
      }}
      startIcon={<ShareOutlined />}
    >
      Share
    </ListingTopSectionAction>
  );
};
